var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPriorityFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6L15 1H3C3 0.4 2.6 0 2 0C1.4 0 1 0.4 1 1V15C1 15.6 1.4 16 2 16C2.6 16 3 15.6 3 15V11H15L13 6Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityFlag);
export default __webpack_public_path__ + "static/media/PriorityFlag.5dcf97a43d83cc5cdaade7998d04be51.svg";
export { ForwardRef as ReactComponent };